export const getCurrentTimestamp = (): string => {
  return new Date().getTime().toString();
};

export const calculateElapsedTimeInSeconds = (startTime: number) => {
  return (new Date().getTime() - startTime) / 1000;
};
